export const KCOM_URLS = ['kutikomi.com', 'kutikomi-stg.com', 'lvh.me', 'kutikomi-qa.com']
export const LOCALONE_URLS = ['localone.jp', 'localone-stg.jp', 'lvh-oem.me']
// TODO: rettyのドメイン確定したら変更する
export const RETTY_URLS = ['retty.me', 'retty-stg.me']
